import Cookies from 'js-cookie';
import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

import { IMPERSONATED_INSTALLATION_ID_COOKIE } from '@/constants/impersonation';

type ImpersonationStore = {
  /** The ID of the installation being impersonated, if any */
  impersonatedInstallationId: number | null;
  /** The name of the installation being impersonated (for display purposes) */
  impersonatedInstallationName: string | null;
  /** Clear all impersonation state */
  clearImpersonation: () => void;
  /** Start impersonating an installation */
  startImpersonation: (installationId: number, installationName: string) => void;
};

export const useImpersonationStore = create<ImpersonationStore>()(
  persist(
    (set, get) => ({
      impersonatedInstallationId: null,
      impersonatedInstallationName: null,
      clearImpersonation: () => {
        console.log('Clearing all impersonation state');
        // Clear cookies
        Cookies.remove(IMPERSONATED_INSTALLATION_ID_COOKIE);

        set({
          impersonatedInstallationId: null,
          impersonatedInstallationName: null,
        });
      },
      startImpersonation: (installationId: number, installationName: string) => {
        console.log('Starting installation impersonation:', { installationId, installationName });
        // Set cookie for server-side access
        Cookies.set(IMPERSONATED_INSTALLATION_ID_COOKIE, String(installationId), {
          path: '/',
          sameSite: 'strict',
        });

        set({
          impersonatedInstallationId: installationId,
          impersonatedInstallationName: installationName,
        });
        console.log('Impersonation state after start:', get());
      },
    }),
    {
      name: 'mrge-impersonation-store',
      storage: createJSONStorage(() => sessionStorage),
      partialize: (state) => ({
        impersonatedInstallationId: state.impersonatedInstallationId,
        impersonatedInstallationName: state.impersonatedInstallationName,
      }),
    },
  ),
);
